import type { CloudEventSettings } from '../@types/CloudEventSettings';
import type { Actions } from '../actions';
import {
  RCV_BRANCH_CLOUD_EVENTS,
  RCV_REMOVE_BRANCH_CLOUD_EVENTS,
  RCV_UPSERT_BRANCH_CLOUD_EVENTS,
  REQ_BRANCH_CLOUD_EVENTS,
  REQ_REMOVE_BRANCH_CLOUD_EVENTS,
  REQ_UPSERT_BRANCH_CLOUD_EVENTS,
  REQUEST_FAILED,
} from '../actions/cloud-events';
import { requestStatus, responseStatus } from '../shared/statuses';

interface CloudEventsState {
  requestStatus: number;
  responseStatus: number;
  settings: { [key: string]: CloudEventSettings[] | undefined };
}

const _initialState: CloudEventsState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  settings: {},
};

let list: CloudEventSettings[] = [];
const cloudEventsReducer = (
  state: CloudEventsState = _initialState,
  action: Actions,
): CloudEventsState => {
  switch (action.type) {
    case REQ_BRANCH_CLOUD_EVENTS:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_BRANCH_CLOUD_EVENTS:
      return {
        ...state,
        settings: {
          ...state.settings,
          [action.id]: action.response,
        },
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_UPSERT_BRANCH_CLOUD_EVENTS:
      return {
        ...state,
        requestStatus: requestStatus.UPDATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_UPSERT_BRANCH_CLOUD_EVENTS:
      list = (state.settings[action.id] || []).slice();
      return {
        ...state,
        settings: {
          ...state.settings,
          [action.id]: list.concat([action.response]),
        },
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_REMOVE_BRANCH_CLOUD_EVENTS:
      return {
        ...state,
        requestStatus: requestStatus.REMOVING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_REMOVE_BRANCH_CLOUD_EVENTS: {
      list = (state.settings[action.id] || []).slice();
      const idx = list.findIndex(
        (x) =>
          x.externalDealerId === action.settings.externalDealerId &&
          x.externalOrganizationId === action.settings.externalOrganizationId,
      );
      if (idx >= 0) {
        list.splice(idx, 1);
      }

      return {
        ...state,
        settings: {
          ...state.settings,
          [action.id]: list,
        },
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    }
    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default cloudEventsReducer;
